module.exports = __webpack_public_path__ + "img/c1.20cec867.png";